import { GWElement } from "./elements.js";
import "./gw.js";
import "./parsed-element.js";
import "./shopify-utils.js";
const PRODUCT_FEED_SOURCES = {
  recentlyViewed: "recently-viewed",
  youMayAlsoLike: "you-may-also-like",
};
const RECENTLY_VIEWED_PRODUCTS_KEY = "recentlyViewedProducts";
class ProductFeed extends GWElement {
  init() {
    super.init();
    this.renderProductFeed();
  }

  get optionDefaults() {
    return {
      source: "recently-viewed",
      title: null,
      fallbackTitle: null,
      ymalUrl: null,
      productsToDisplay: 4,
      showDesktopSlider: false,
      showMobileSlider: false,
      mannequinImageFirst: false,
      productImageCarousel: false,
      selectors: {
        productFeedContainer: "[product-feed-container]",
        productFeedTitle: "[data-product-feed-title]",
        fallbackProductsTemplate: 'template[name="fallback-products"]',
      },
    };
  }

  get productFeedContainer() {
    return this.querySelector(this.options.selectors.productFeedContainer);
  }

  renderProductFeed() {
    switch (this.options.source) {
      case PRODUCT_FEED_SOURCES.recentlyViewed:
        this.renderRecentlyViewed();
        break;
      case PRODUCT_FEED_SOURCES.youMayAlsoLike:
        this.renderYouMayAlsoLike();
        break;
      default:
        console.warn(`Unknown source: ${this.options.source}`);
    }
  }

  resetSliderComponent() {
    const $sliderComponent = this.querySelector("slider-component");
    if ($sliderComponent) {
      $sliderComponent.resetPages();
    }
  }

  async renderProducts(products) {
    const splicedProducts = products
      .filter((product) => product.handle !== "routeins")
      .splice(0, this.options.productsToDisplay);
    await Promise.all(
      splicedProducts.map(async (product, index) => {
        const $gridItem = document.createElement("li");
        $gridItem.setAttribute(
          "id",
          `Slide-${this.querySelector(".slider").id.replace("Slider-", "")}-${index + 1}`,
        );
        $gridItem.classList.add(
          "grid__item",
          "slider__slide",
          "scroll-trigger",
          "animate--slide-in",
        );
        $gridItem.setAttribute("data-cascade", "");
        $gridItem.setAttribute("style", `--animation-order: ${index + 1};`);
        const $cardWrapper = document.createElement("div");
        $cardWrapper.classList.add(
          "card-wrapper",
          "product-card-wrapper",
          "underline-links-hover",
        );
        $cardWrapper.setAttribute("data-gw-product-card-selector", "");
        const $cardProduct = document.createElement("card-product");
        $cardProduct.classList.add("card", "card--standard", "card--media");
        $cardProduct.setAttribute("product-handle", product.handle);
        if (this.options.mannequinImageFirst) {
          $cardProduct.setAttribute("mannequin-image-first", "true");
        }
        if (this.options.productImageCarousel) {
          $cardProduct.setAttribute("product-image-carousel", "true");
        }
        $cardWrapper.appendChild($cardProduct);
        $gridItem.appendChild($cardWrapper);
        this.productFeedContainer.appendChild($gridItem);
        return new Promise((resolve) => {
          $cardProduct.addEventListener("product-card:load", resolve, {
            once: true,
          });
        });
      }),
    );
    this.dispatchEvent(
      new CustomEvent("product-feed:load", {
        bubbles: true,
        detail: { containerSelector: `#${this.id}`, products: splicedProducts },
      }),
    );
    this.resetSliderComponent();
  }

  renderFallbackProducts() {
    const $productFeedTitle = this.querySelector(
      this.options.selectors.productFeedTitle,
    );
    const fallbackTitle = this.options.fallbackTitle;
    if (fallbackTitle && $productFeedTitle) {
      $productFeedTitle.textContent = fallbackTitle;
    }
    const $fallbackProductsTemplate = this.querySelector(
      this.options.selectors.fallbackProductsTemplate,
    );
    if (!$fallbackProductsTemplate) {
      this.remove();
      return;
    }
    const $productSliderItems =
      $fallbackProductsTemplate.content.querySelectorAll(".grid__item");
    $productSliderItems.forEach((item) => {
      this.productFeedContainer.appendChild(item);
    });
    this.resetSliderComponent();
  }

  renderRecentlyViewed() {
    const recentlyViewedData =
      JSON.parse(localStorage.getItem(RECENTLY_VIEWED_PRODUCTS_KEY)) || [];
    const recentlyViewedProducts = recentlyViewedData
      .filter(Boolean)
      .toReversed();
    if (!recentlyViewedProducts.length) {
      this.renderFallbackProducts();
      return;
    }
    const products = recentlyViewedProducts.map((productHandle) => {
      return {
        handle: productHandle,
      };
    });
    this.renderProducts(products);
  }

  renderYouMayAlsoLike() {
    fetch(this.options.ymalUrl, { priority: "low" })
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, "text/html");
        const $sliderComponent = html.querySelector("slider-component");
        const $currentSliderComponent = this.querySelector("slider-component");
        $currentSliderComponent.replaceWith($sliderComponent);
      });
  }
}
customElements.define("product-feed", ProductFeed);
